// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Di bawah 635px */
@media screen and (max-width: 635px) {
  /* Detail Restaurant */

  .detail-restaurant {
    margin-top: 150px;
  }

  .image-detail-wrapper img {
    width: 90%;
    height: auto;
  }

  .restaurant-detail-head {
    margin-left: 25px;
    color: black;
  }

  .restaurant-detail-head h1 {
    font-size: 1.2rem;
  }

  .rating-detail-container {
    font-size: 0.9rem;
    margin-top: 2px;
  }

  .fa-star.detail {
    color: black;
    font-size: 0.9rem;
  }

  .city-address-detail-container {
    right: auto;
    text-align: left;
    font-size: 0.8rem;
    top: auto;
    margin: 45px 27px;
  }

  .restaurant-detail-category-container {
    margin-left: 26px;
    margin-top: 10px;
    font-size: 0.7rem;
    bottom: -7px;
    position: static;
  }

  .button-detail-container {
    right: auto;
    top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 60px auto 0 27px;
    text-align: center;
  }

  .button-detail-container .favorite {
    padding: 12px;
    cursor: pointer;
    font-size: 0.7rem;
  }

  .button-detail-container .favorite i {
    font-size: 0.8rem;
  }

  .detail-description {
    width: 90%;
    margin: 140px auto 0 auto;
    font-size: 14px;
    line-height: 1.7;
    text-align: justify;
  }
  /* End Detail Restaurant */

  /* Menus */

  .menus-detail-container {
    width: 90%;
    text-align: center;
    margin: auto;
  }

  .food-item {
    width: 100%;
  }

  .food-text,
  .drink-text {
    margin-top: 35px;
  }
  /* End Menus */

  /* Reviews */
  .review-card-container {
    gap: 5px;
  }

  .review-card {
    width: 100%;
    margin: 0 0 20px;
  }

  .review-details h3 {
    font-size: 1rem;
  }

  .review-details p {
    font-size: 0.8rem;
  }

  .review-content p {
    font-size: 0.9rem;
  }
  /* End Reviews */

  /* Review Form */
  .review-form {
    width: 90%;
  }

  /* End Review Form */
}

/* Di atas 636px dan di bawah 768px*/
@media screen and (min-width: 636px) and (max-width: 767px) {
  /* Detail Restaurant */
  .restaurant-detail-head {
    margin-left: 77px;
  }

  .restaurant-detail-head h1 {
    font-size: 1.2rem;
  }

  .rating-detail-container {
    font-size: 0.9rem;
    margin-bottom: 4px;
  }

  .city-address-detail-container {
    right: 80px;
    top: 85%;
    font-size: 0.8rem;
  }

  .restaurant-detail-category-container {
    margin-left: 77px;
  }

  .restaurant-detail-category-container > div {
    font-size: 0.8rem;
  }

  .button-detail-container {
    right: 77px;
    top: 96%;
  }

  .button-detail-container .favorite {
    font-size: 0.6rem;
    padding: 5px;
  }

  .button-detail-container .favorite i {
    font-size: 12px;
  }
  /* Detail Restaurant */

  /* Menus */
  .menus-detail-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
  }

  .foods-container,
  .drinks-container {
    width: 100%;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
  }

  .food-item,
  .drink-item {
    width: calc(33.33% - 20px);
    margin: 5px auto;
    text-align: left;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
  }
  /* End Menus */

  /* Reviews */
  .review-card {
    width: 48%;
    margin: 0 1%;
  }

  .review-details h3 {
    font-size: 1rem;
  }

  .review-details p {
    font-size: 0.8rem;
  }

  .review-content p {
    font-size: 0.9rem;
  }
  /* End Reviews */
}

/* 768px - 1023px */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  /* Detail Restaurant */
  .image-detail-wrapper img {
    width: 85%;
  }

  .restaurant-detail-head {
    margin-left: 75px;
  }

  .restaurant-detail-head h1 {
    font-size: 1.5rem;
  }

  .rating-detail-container {
    font-size: 1rem;
    margin: 0 auto 0 10px;
  }

  .city-address-detail-container {
    right: 80px;
    top: 86%;
    font-size: 0.9rem;
  }

  .restaurant-detail-category-container {
    margin-left: 75px;
  }

  .button-detail-container {
    right: 80px;
    top: 96%;
  }
  /* End Detail Restaurant */

  /* Menus */
  .menus-detail-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
  }

  .foods-container,
  .drinks-container {
    width: 100%;
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
  }

  .food-item,
  .drink-item {
    width: calc(33.33% - 20px);
    margin: 5px auto;
    text-align: left;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
  }
  /* End Menus */

  /* Reviews */
  .review-card {
    width: 30%;
    margin: 0 1%;
  }

  .review-details h3 {
    font-size: 1rem;
  }

  .review-details p {
    font-size: 0.8rem;
  }

  /* Mengatur ukuran font isi review */
  .review-content p {
    font-size: 0.9rem;
  }
  /* End Reviews */
}

/* 1024px - 1365px */
@media screen and (min-width: 1024px) and (max-width: 1365px) {
  /* Detail Restaurants */
  .image-detail-wrapper img {
    width: 85%;
  }

  .restaurant-detail-head {
    margin-left: 90px;
  }

  .city-address-detail-container {
    right: 100px;
    top: 462px;
    font-size: 0.9rem;
  }

  .restaurant-detail-category-container {
    margin-left: 90px;
  }

  .button-detail-container {
    right: 100px;
    top: 522px;
  }
  /* End Detail Restaurants */

  /* Menus */
  .menus-detail-container {
    width: 90%;
  }
  /* End Menus */

  /* Reviews */
  .review-card {
    width: 30%;
    margin: 0 1%;
  }

  .review-details h3 {
    font-size: 1rem;
  }

  .review-details p {
    font-size: 0.8rem;
  }

  .review-content p {
    font-size: 0.9rem;
  }
  /* End Reviews */
}

/* Lebar di atas 1366 dan tingginya 611px */
@media screen and (min-width: 1366px) and (min-height: 611px) {
  .city-address-detail-container {
    right: 135px;
    top: 83%;
    font-size: 0.9rem;
  }

  .button-detail-container {
    right: 135px;
    top: 92%;
  }
}

/* Lebar di atas 1366 dan tingginya 612px */
@media screen and (min-width: 1366px) and (min-height: 612px) {
  .city-address-detail-container {
    right: 135px;
    top: 80%;
    font-size: 0.9rem;
  }

  .button-detail-container {
    right: 135px;
    top: 89%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/detail-responsive.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,sBAAsB;;EAEtB;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA,0BAA0B;;EAE1B,UAAU;;EAEV;IACE,UAAU;IACV,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,gBAAgB;EAClB;EACA,cAAc;;EAEd,YAAY;EACZ;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA,gBAAgB;;EAEhB,gBAAgB;EAChB;IACE,UAAU;EACZ;;EAEA,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA,sBAAsB;;EAEtB,UAAU;EACV;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sCAAsC;IACtC,eAAe;EACjB;EACA,cAAc;;EAEd,YAAY;EACZ;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;EACA,0BAA0B;;EAE1B,UAAU;EACV;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sCAAsC;IACtC,eAAe;EACjB;EACA,cAAc;;EAEd,YAAY;EACZ;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,iBAAiB;EACnB;EACA,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;EACA,2BAA2B;;EAE3B,UAAU;EACV;IACE,UAAU;EACZ;EACA,cAAc;;EAEd,YAAY;EACZ;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE;IACE,YAAY;IACZ,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,YAAY;IACZ,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;AACF","sourcesContent":["/* Di bawah 635px */\n@media screen and (max-width: 635px) {\n  /* Detail Restaurant */\n\n  .detail-restaurant {\n    margin-top: 150px;\n  }\n\n  .image-detail-wrapper img {\n    width: 90%;\n    height: auto;\n  }\n\n  .restaurant-detail-head {\n    margin-left: 25px;\n    color: black;\n  }\n\n  .restaurant-detail-head h1 {\n    font-size: 1.2rem;\n  }\n\n  .rating-detail-container {\n    font-size: 0.9rem;\n    margin-top: 2px;\n  }\n\n  .fa-star.detail {\n    color: black;\n    font-size: 0.9rem;\n  }\n\n  .city-address-detail-container {\n    right: auto;\n    text-align: left;\n    font-size: 0.8rem;\n    top: auto;\n    margin: 45px 27px;\n  }\n\n  .restaurant-detail-category-container {\n    margin-left: 26px;\n    margin-top: 10px;\n    font-size: 0.7rem;\n    bottom: -7px;\n    position: static;\n  }\n\n  .button-detail-container {\n    right: auto;\n    top: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 60px auto 0 27px;\n    text-align: center;\n  }\n\n  .button-detail-container .favorite {\n    padding: 12px;\n    cursor: pointer;\n    font-size: 0.7rem;\n  }\n\n  .button-detail-container .favorite i {\n    font-size: 0.8rem;\n  }\n\n  .detail-description {\n    width: 90%;\n    margin: 140px auto 0 auto;\n    font-size: 14px;\n    line-height: 1.7;\n    text-align: justify;\n  }\n  /* End Detail Restaurant */\n\n  /* Menus */\n\n  .menus-detail-container {\n    width: 90%;\n    text-align: center;\n    margin: auto;\n  }\n\n  .food-item {\n    width: 100%;\n  }\n\n  .food-text,\n  .drink-text {\n    margin-top: 35px;\n  }\n  /* End Menus */\n\n  /* Reviews */\n  .review-card-container {\n    gap: 5px;\n  }\n\n  .review-card {\n    width: 100%;\n    margin: 0 0 20px;\n  }\n\n  .review-details h3 {\n    font-size: 1rem;\n  }\n\n  .review-details p {\n    font-size: 0.8rem;\n  }\n\n  .review-content p {\n    font-size: 0.9rem;\n  }\n  /* End Reviews */\n\n  /* Review Form */\n  .review-form {\n    width: 90%;\n  }\n\n  /* End Review Form */\n}\n\n/* Di atas 636px dan di bawah 768px*/\n@media screen and (min-width: 636px) and (max-width: 767px) {\n  /* Detail Restaurant */\n  .restaurant-detail-head {\n    margin-left: 77px;\n  }\n\n  .restaurant-detail-head h1 {\n    font-size: 1.2rem;\n  }\n\n  .rating-detail-container {\n    font-size: 0.9rem;\n    margin-bottom: 4px;\n  }\n\n  .city-address-detail-container {\n    right: 80px;\n    top: 85%;\n    font-size: 0.8rem;\n  }\n\n  .restaurant-detail-category-container {\n    margin-left: 77px;\n  }\n\n  .restaurant-detail-category-container > div {\n    font-size: 0.8rem;\n  }\n\n  .button-detail-container {\n    right: 77px;\n    top: 96%;\n  }\n\n  .button-detail-container .favorite {\n    font-size: 0.6rem;\n    padding: 5px;\n  }\n\n  .button-detail-container .favorite i {\n    font-size: 12px;\n  }\n  /* Detail Restaurant */\n\n  /* Menus */\n  .menus-detail-container {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: auto;\n  }\n\n  .foods-container,\n  .drinks-container {\n    width: 100%;\n    display: flex;\n    justify-content: start;\n    flex-wrap: wrap;\n  }\n\n  .food-item,\n  .drink-item {\n    width: calc(33.33% - 20px);\n    margin: 5px auto;\n    text-align: left;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease-in-out;\n    cursor: pointer;\n  }\n  /* End Menus */\n\n  /* Reviews */\n  .review-card {\n    width: 48%;\n    margin: 0 1%;\n  }\n\n  .review-details h3 {\n    font-size: 1rem;\n  }\n\n  .review-details p {\n    font-size: 0.8rem;\n  }\n\n  .review-content p {\n    font-size: 0.9rem;\n  }\n  /* End Reviews */\n}\n\n/* 768px - 1023px */\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  /* Detail Restaurant */\n  .image-detail-wrapper img {\n    width: 85%;\n  }\n\n  .restaurant-detail-head {\n    margin-left: 75px;\n  }\n\n  .restaurant-detail-head h1 {\n    font-size: 1.5rem;\n  }\n\n  .rating-detail-container {\n    font-size: 1rem;\n    margin: 0 auto 0 10px;\n  }\n\n  .city-address-detail-container {\n    right: 80px;\n    top: 86%;\n    font-size: 0.9rem;\n  }\n\n  .restaurant-detail-category-container {\n    margin-left: 75px;\n  }\n\n  .button-detail-container {\n    right: 80px;\n    top: 96%;\n  }\n  /* End Detail Restaurant */\n\n  /* Menus */\n  .menus-detail-container {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: auto;\n  }\n\n  .foods-container,\n  .drinks-container {\n    width: 100%;\n    display: flex;\n    justify-content: start;\n    flex-wrap: wrap;\n  }\n\n  .food-item,\n  .drink-item {\n    width: calc(33.33% - 20px);\n    margin: 5px auto;\n    text-align: left;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease-in-out;\n    cursor: pointer;\n  }\n  /* End Menus */\n\n  /* Reviews */\n  .review-card {\n    width: 30%;\n    margin: 0 1%;\n  }\n\n  .review-details h3 {\n    font-size: 1rem;\n  }\n\n  .review-details p {\n    font-size: 0.8rem;\n  }\n\n  /* Mengatur ukuran font isi review */\n  .review-content p {\n    font-size: 0.9rem;\n  }\n  /* End Reviews */\n}\n\n/* 1024px - 1365px */\n@media screen and (min-width: 1024px) and (max-width: 1365px) {\n  /* Detail Restaurants */\n  .image-detail-wrapper img {\n    width: 85%;\n  }\n\n  .restaurant-detail-head {\n    margin-left: 90px;\n  }\n\n  .city-address-detail-container {\n    right: 100px;\n    top: 462px;\n    font-size: 0.9rem;\n  }\n\n  .restaurant-detail-category-container {\n    margin-left: 90px;\n  }\n\n  .button-detail-container {\n    right: 100px;\n    top: 522px;\n  }\n  /* End Detail Restaurants */\n\n  /* Menus */\n  .menus-detail-container {\n    width: 90%;\n  }\n  /* End Menus */\n\n  /* Reviews */\n  .review-card {\n    width: 30%;\n    margin: 0 1%;\n  }\n\n  .review-details h3 {\n    font-size: 1rem;\n  }\n\n  .review-details p {\n    font-size: 0.8rem;\n  }\n\n  .review-content p {\n    font-size: 0.9rem;\n  }\n  /* End Reviews */\n}\n\n/* Lebar di atas 1366 dan tingginya 611px */\n@media screen and (min-width: 1366px) and (min-height: 611px) {\n  .city-address-detail-container {\n    right: 135px;\n    top: 83%;\n    font-size: 0.9rem;\n  }\n\n  .button-detail-container {\n    right: 135px;\n    top: 92%;\n  }\n}\n\n/* Lebar di atas 1366 dan tingginya 612px */\n@media screen and (min-width: 1366px) and (min-height: 612px) {\n  .city-address-detail-container {\n    right: 135px;\n    top: 80%;\n    font-size: 0.9rem;\n  }\n\n  .button-detail-container {\n    right: 135px;\n    top: 89%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
